const store = {
    namespaced: true,
    state() {
        return {
            orders: null,
            pages: null,
            filters: null
        };
    },
    getters: {
        orders: state => state.orders,
        pages: state => state.pages,
        filters: state => state.filters
    },
    mutations: {
        SET_ORDER: (state, data) => (state.orders = data),
        SET_PAGES: (state, data) => (state.pages = data),
        SET_FILTERS: (state, data) => (state.filters = data)
    },
    actions: {
        fetchOrders: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'GET',
                    url: `/general/orders_list?start_date=2023-9-4&end_date=2023-9-5&page=1`
                });
                commit('SET_ORDER', res.data.orders);
                commit('SET_PAGES', {
                    pages: res.data.pages,
                    current_page: res.data.current_page,
                    totalCount: res.data.totalCount
                });
                commit('SET_FILTERS', res.data.filters);
            } catch (error) {
                console.dir(error);
            }
        }
    }
};

export default store;
